import React, { useEffect, useState } from "react";

export default function Dragable({
  children,
  top,
  bottom,
  left,
  right,
  name,
  notes,
}) {
  const [isDragging, setIsDragging] = useState(false);

  function dragElement(elmnt) {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    // if (document.getElementById(elmnt.id + "header")) {
    //   /* if present, the header is where you move the DIV from:*/
    //   document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    // } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onmousedown = dragMouseDown;
    // }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      setIsDragging(true);
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      setIsDragging(false);
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  useEffect(() => {
    dragElement(document.getElementById(`mydiv-${name}`));
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top,
        bottom,
        left,
        right,
        zIndex: 20,
        maxWidth: "56px",
        maxHeight: "56px",
        pointerEvents: isDragging ? "none" : "auto",
      }}
      id={`mydiv-${name}`}
    >
      <div
        id={`mydivheader-${name}`}
        style={{
          zIndex: "10",
        }}
      >
        {children}
      </div>
    </div>
  );
}
